import { getDefaultHeaders, setCsrfToken } from "./utils";

export const submitToCMS = async (formData) => {
    let headers = await getDefaultHeaders(false, true);
    try {
        const response = await fetch(`/api/submit-to-cms/`, {
          headers:headers,
          method: 'POST',
          body: formData,
        });
    
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.detail || 'Failed to save erased image');
        }
    
        return await response.json();
      } catch (error) {
        console.error('Error in submit to cms API call:', error);
        return { success: false, error: error.message };
      }
}